import * as React from 'react';

import cn from 'classnames';

import { BaseButton } from '../BaseButton';

import { IContainedButtonProps } from './types';

import * as s from './ContainedButton.scss';

export const ContainedButton = ({ withIcon, className, ...props }: IContainedButtonProps) => (
	<BaseButton
		{...props}
		className={cn(
			s.button,
			className,
			{
				[s.disabled]: props.isDisabled,
			},
		)}
	>
		{props.children}
	</BaseButton>
);
